import { controls, grouped } from "../controls";
const assign_village_to_branches = {
  label: "Assign Village To Branches",
  pageLabel: "Assign Village To Branches", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  bulk: { columns: ["taluka_id", "village_id", "branch_id"] },
  formTabs:
  {
    allTabs: [
      { label: "General", uid: "general" },
      { label: "Bulk", uid: "bulk" }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "Taluka" }),
    ...controls.oc({ tab: "filter", c: "Taluka", placeHolder: "Taluka Code", name: "AssignVillageToBranch-taluka-taluka_code", fastpath: "talukas" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AssignVillageToBranch-taluka-taluka_display" }),
    ...controls.displayText({ tab: "filter", label: "Village" }),
    ...controls.oc({ tab: "filter", c: "Village", placeHolder: "Village Code", name: "AssignVillageToBranch-village-village_code", fastpath: "villages" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AssignVillageToBranch-village-village_display" }),
    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", placeHolder: "Branch Code", name: "AssignVillageToBranch-branch-branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AssignVillageToBranch-branch-branch_display" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Taluka", star: true }),
    ...controls.oc({ tab: "general", c: "Taluka", placeHolder: "Taluka Code", name: "taluka_code", isRequired: true, fastpath: "talukas", isReadOnly: "edit", clearData: ['village_code'], hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display" }),
    ...controls.displayText({ tab: "general", label: "Village", star: true }),
    ...controls.oc({ tab: "general", c: "Village", placeHolder: "Village Code", name: "village_code", isRequired: true, fastpath: "villages", isReadOnly: "edit", sendToServer: { sendData: [{ varname: 'taluka.taluka_uid', value: 'taluka_uid' }] }, hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "village_display" }),
    ...controls.displayText({ tab: "general", label: "Branch", star: false }),
    ...controls.oc({ tab: "general", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches", isReadOnly: "edit", hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display" }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Assign Village To Branches",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Branch Code", accessor: "AssignVillageToBranch-branch-branch_code", },
      { Header: "Branch", accessor: "AssignVillageToBranch-branch-branch_display", },
      { Header: "Taluka", accessor: "AssignVillageToBranch-taluka-taluka_display", },
      { Header: "Village", accessor: "AssignVillageToBranch-village-village_display", },
    ]
  }
};
export default assign_village_to_branches;